import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Box, Heading } from 'chemistry'
import List from 'client/common/components/crossSell/List'
import { TranslateContext } from 'client/common/translator'
import { Divider } from 'client/common/components/Divider'
import { isFlagPushedToDataLayer, pushTrackedFlagToDataLayer } from '../../gtmEvents'
import { SHOW_SOLD_BY_PRODUCT_CARDS } from 'common/constants'

const COMPONENT_NAME = 'productDetailsCrossSellProducts'

const isEmptyResponse = (loading, collection) => !loading && collection?.length === 0

const CrossSellProducts = props => {
  const {
    lang,
    format,
    loading,
    error,
    data,
    titleKey,
    titleElem,
    rootClassName,
    onProductClick,
    crossSellRef,
    count,
    headerButton,
    sizes = ['sm', 'md'],
    checkedProducts,
    onProductCheck,
    target,
    listProps,
    cardWrapperProps,
    showBVRatingOnListerCards,
    showSoldByProductCards,
    flagsToGA,
    pageType,
    inView
  } = props
  const t = useContext(TranslateContext)

  useEffect(() => {
    if (inView && !isFlagPushedToDataLayer(SHOW_SOLD_BY_PRODUCT_CARDS)) {
      pushTrackedFlagToDataLayer({
        flagsToGA,
        ldFlag: SHOW_SOLD_BY_PRODUCT_CARDS,
        ...(pageType ? { pageType } : {})
      })
    }
  }, [flagsToGA, inView, pageType])

  if (error) return null
  const collection = data?.products?.collection
  return (
    <Box ref={crossSellRef} className={rootClassName}>
      {!isEmptyResponse(loading, collection) && (
        <Box>
          <Divider />
          <Heading
            my='0'
            fontSize='24px'
            lineHeight='1.33'
            letterSpacing='.17px'
            color='var(--chakra-colors-greyishBrownTwo-600)'
          >
            {t(titleKey)} {titleElem}
          </Heading>
          {headerButton}
          <Box
            as='section'
            overflow='auto'
            position='relative'
            margin='0 -16px'
            data-scroll-begin='begin'
            data-scroll-end='end'
          >
            <List
              {...{
                collection,
                loading,
                lang,
                format,
                onProductClick,
                count,
                sizes,
                checkedProducts,
                onProductCheck,
                target,
                listProps,
                cardWrapperProps,
                showBVRatingOnListerCards,
                showSoldByProductCards
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

CrossSellProducts.displayName = COMPONENT_NAME

CrossSellProducts.propTypes = {
  productCode: PropTypes.string,
  format: PropTypes.string,
  lang: PropTypes.string,
  listProps: PropTypes.object,
  cardWrapperProps: PropTypes.object
}

export default CrossSellProducts
